var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-wrapper',[_c('vs-alert',{attrs:{"type":"info"}},[_c('v-icon',{staticClass:"icon-fix",attrs:{"color":"blue lighten-1"}},[_vm._v("check_box_outlined")]),_c('b',[_vm._v(_vm._s(_vm.actionsRequiredStatusLabel))]),_vm._v(" "+_vm._s(_vm.actionsRequiredAssignedLabel)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }